// Hand-drawn line silhouettes for each furniture category.
// All use stroke="currentColor" so they pick up the parent text color.
// 100×100 viewBox, stroke-width 2, rounded ends.

const baseProps = {
  viewBox: "0 0 100 100",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

// eslint-disable-next-line react/prop-types
const W = ({ children, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...baseProps} {...rest}>
    {children}
  </svg>
);

const Armoire = (props) => (
  <W {...props}>
    <rect x="22" y="14" width="56" height="74" rx="1" />
    <line x1="50" y1="14" x2="50" y2="88" />
    <circle cx="44" cy="50" r="1.4" />
    <circle cx="56" cy="50" r="1.4" />
    <line x1="22" y1="88" x2="20" y2="92" />
    <line x1="78" y1="88" x2="80" y2="92" />
  </W>
);

const Bedframe = (props) => (
  <W {...props}>
    <rect x="14" y="38" width="72" height="34" rx="1" />
    <rect x="14" y="22" width="72" height="20" rx="1" />
    <line x1="14" y1="72" x2="14" y2="84" />
    <line x1="86" y1="72" x2="86" y2="84" />
    <line x1="50" y1="38" x2="50" y2="22" />
    <line x1="32" y1="56" x2="68" y2="56" />
  </W>
);

const Cabinet = (props) => (
  <W {...props}>
    <rect x="20" y="16" width="60" height="72" />
    <line x1="50" y1="16" x2="50" y2="88" />
    <line x1="20" y1="44" x2="80" y2="44" />
    <line x1="20" y1="66" x2="80" y2="66" />
    <circle cx="44" cy="32" r="1.3" />
    <circle cx="56" cy="32" r="1.3" />
  </W>
);

const Chest = (props) => (
  <W {...props}>
    <path d="M18 50 q32 -22 64 0 v32 h-64 z" />
    <line x1="18" y1="62" x2="82" y2="62" />
    <rect x="46" y="56" width="8" height="10" />
    <line x1="18" y1="82" x2="14" y2="88" />
    <line x1="82" y1="82" x2="86" y2="88" />
  </W>
);

const CoffeeTable = (props) => (
  <W {...props}>
    <rect x="12" y="44" width="76" height="10" rx="1" />
    <line x1="20" y1="54" x2="20" y2="78" />
    <line x1="80" y1="54" x2="80" y2="78" />
    <line x1="20" y1="78" x2="80" y2="78" />
    <line x1="20" y1="62" x2="80" y2="62" />
  </W>
);

const Desk = (props) => (
  <W {...props}>
    <rect x="14" y="32" width="72" height="8" />
    <rect x="14" y="40" width="22" height="38" />
    <line x1="14" y1="60" x2="36" y2="60" />
    <circle cx="32" cy="50" r="1.2" />
    <line x1="84" y1="40" x2="84" y2="80" />
    <line x1="14" y1="80" x2="84" y2="80" />
  </W>
);

const DiningChair = (props) => (
  <W {...props}>
    <line x1="34" y1="14" x2="34" y2="88" />
    <line x1="34" y1="14" x2="60" y2="14" />
    <line x1="34" y1="34" x2="60" y2="34" />
    <line x1="34" y1="50" x2="68" y2="50" />
    <line x1="68" y1="50" x2="68" y2="88" />
    <line x1="34" y1="50" x2="34" y2="88" />
  </W>
);

const DiningTable = (props) => (
  <W {...props}>
    <rect x="10" y="36" width="80" height="10" rx="1" />
    <line x1="20" y1="46" x2="20" y2="82" />
    <line x1="80" y1="46" x2="80" y2="82" />
  </W>
);

const Dresser = (props) => (
  <W {...props}>
    <rect x="18" y="22" width="64" height="62" />
    <line x1="18" y1="40" x2="82" y2="40" />
    <line x1="18" y1="55" x2="82" y2="55" />
    <line x1="18" y1="70" x2="82" y2="70" />
    <circle cx="44" cy="31" r="1.2" />
    <circle cx="56" cy="31" r="1.2" />
    <circle cx="44" cy="47" r="1.2" />
    <circle cx="56" cy="47" r="1.2" />
    <circle cx="44" cy="62" r="1.2" />
    <circle cx="56" cy="62" r="1.2" />
    <circle cx="44" cy="77" r="1.2" />
    <circle cx="56" cy="77" r="1.2" />
  </W>
);

const Hutch = (props) => (
  <W {...props}>
    <rect x="20" y="10" width="60" height="44" />
    <line x1="20" y1="26" x2="80" y2="26" />
    <line x1="20" y1="40" x2="80" y2="40" />
    <line x1="50" y1="10" x2="50" y2="40" />
    <rect x="18" y="54" width="64" height="34" />
    <line x1="50" y1="54" x2="50" y2="88" />
    <circle cx="44" cy="70" r="1.3" />
    <circle cx="56" cy="70" r="1.3" />
  </W>
);

const Sideboard = (props) => (
  <W {...props}>
    <rect x="10" y="32" width="80" height="40" />
    <line x1="36" y1="32" x2="36" y2="72" />
    <line x1="64" y1="32" x2="64" y2="72" />
    <circle cx="50" cy="52" r="1.2" />
    <line x1="14" y1="72" x2="14" y2="84" />
    <line x1="86" y1="72" x2="86" y2="84" />
  </W>
);

const Sidetable = (props) => (
  <W {...props}>
    <rect x="26" y="36" width="48" height="14" />
    <line x1="26" y1="46" x2="74" y2="46" />
    <circle cx="50" cy="44" r="1.2" />
    <line x1="32" y1="50" x2="32" y2="80" />
    <line x1="68" y1="50" x2="68" y2="80" />
  </W>
);

const SILHOUETTES = {
  armoire: Armoire,
  bedframe: Bedframe,
  cabinet: Cabinet,
  chest: Chest,
  "coffee-table": CoffeeTable,
  desk: Desk,
  "dining-chair": DiningChair,
  "dining-table": DiningTable,
  dresser: Dresser,
  hutch: Hutch,
  sideboard: Sideboard,
  sidetable: Sidetable,
};

export default function CategorySilhouette({ slug, className = "" }) {
  const Comp = SILHOUETTES[slug];
  if (!Comp) return null;
  return <Comp className={className} />;
}
